import { AxiosPromise } from 'axios';
import { http } from 'SharedDir/backend/axios/http';
import { AUTHORIZATION } from 'SharedDir/backend/endpoints/access';
import {
  EsiaLogin,
  EsiaRedirectInfo,
  LoginUserInfo,
  RegisterUserInfo,
  ResetPassword,
  UserInfo,
} from 'SharedDir/declarations/access';
import { UserBrief } from 'SharedDir/declarations/user';
import { ACCOUNT } from 'SharedDir/backend/endpoints/account';
import { StatusResponse } from 'SharedDir/declarations/endpoint';

export default class AccessApi {
  public static async login(data): Promise<LoginUserInfo> {
    const responseData: LoginUserInfo = await http({
      ...AUTHORIZATION.LOGIN,
      data,
    })
      .then((r): LoginUserInfo => r.data)
      .catch((e) => {
        throw e;
      });
    return responseData;
  }

  public static async logout(): Promise<string> {
    const responseData: string = await http({
      ...AUTHORIZATION.LOGOUT,
      headers: {
        interceptors: false,
      },
    })
      .then((r): string => r.data)
      .catch((e) => {
        throw e;
      });
    return responseData;
  }

  public static async resetPassword(data): Promise<ResetPassword> {
    const responseData: ResetPassword = await http({
      ...AUTHORIZATION.RESET_PASSWORD,
      data: { email: data },
    })
      .then((r): ResetPassword => r.data)
      .catch((e) => {
        throw e;
      });
    return responseData;
  }

  public static async resetPasswordConfirm(data): Promise<UserBrief> {
    const responseData: UserBrief = await http({
      ...AUTHORIZATION.RESET_PASSWORD_CONFIRM,
      data,
    })
      .then((r): UserBrief => r.data)
      .catch((e) => {
        throw e;
      });

    return responseData;
  }

  public static async registration(data): Promise<RegisterUserInfo> {
    const responseData: RegisterUserInfo = await http({
      ...AUTHORIZATION.REGISTER,
      data,
    })
      .then((r): RegisterUserInfo => r.data)
      .catch((e) => {
        throw e;
      });
    return responseData;
  }

  public static async changeTempPassword(data): Promise<UserBrief> {
    const responseData: UserBrief = await http({
      ...AUTHORIZATION.CHANGE_TEMP_PASSWORD,
      data,
    })
      .then((r): UserBrief => r.data)
      .catch((e) => {
        throw e;
      });
    return responseData;
  }

  static async me() {
    let data: UserInfo | null = null;
    try {
      ({ data } = await http(ACCOUNT.MY_ACCOUNT));
    } catch (error: any) {
      // Сетевая ошибка и Error из getHttp() не имеют response.
      // e.response.data роняет SSR: исключение из catch не перехватывается и валит рендер.
      console.error(error?.response?.data?.detail ?? error);
    }
    return data;
  }

  static async getEsiaRedirectAuthUrl(): Promise<EsiaRedirectInfo> {
    const { data } = await (<AxiosPromise<EsiaRedirectInfo>>(
      http({ ...AUTHORIZATION.ESIA_AUTH_URL })
    ));

    return data;
  }

  static async loginEsia(esiaParams: EsiaLogin): Promise<LoginUserInfo> {
    const { data } = await (<AxiosPromise<LoginUserInfo>>(
      http({ ...AUTHORIZATION.ESIA_LOGIN, data: esiaParams })
    ));

    return data;
  }

  static async loginUgraId(code: string, state: string) {
    const { data } = await (<AxiosPromise<LoginUserInfo>>(
      http({ ...AUTHORIZATION.UGRA_ID_AUTH, params: { code, state }, withCredentials: true })
    ));
    return data;
  }

  /**
 * Првоерка каптчи
 * @returns
 */
  public static async checkYandexCaptcha(
    token: string
  ): Promise<{ status: number, data: StatusResponse }> {
    const data = {
      token
    };
    const response = await http({
      ...AUTHORIZATION.YANDEX_CAPTCHA,
      data,
    });

    return response;
  }
}
